// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CommonAssetDto = any; // TODO entities/assets/CommonAssetDto

export enum TransferIndexFieldGroup {
  CRUCIAL = 5,
  ESSENTIAL = 4,
  NECESSARY = 2,
  OTHER = 1,
}
